import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import "./HighlightedPest.css";

function HighlightedPest({ pestData }) {
  HighlightedPest.propTypes = {
    pestData: PropTypes.exact({
      pestImageURL: PropTypes.string,
      pestImageDescription: PropTypes.string,
      commonName: PropTypes.string,
      scientificName: PropTypes.string,
      origin: PropTypes.string,
      category: PropTypes.string,
      region: PropTypes.string,
      learnMoreLink: PropTypes.string,
    }),
  };
  const navigate = useNavigate();

  return (
    <div
      className="grid-row highlighted-pest-section"
      data-testid="highlighted-pest-div"
    >
      <div className="tablet:grid-col-6 mobile-lg:grid-col-12">
        <img
          src={pestData.pestImageURL}
          width="100%"
          alt={pestData.pestImageDescription}
          className="highlighted-pest-image"
        />
      </div>
      <div className="tablet:grid-col-6 mobile-lg:grid-col-12">
        <div className="highlighted-pest-common-name">
          {pestData.commonName}
        </div>
        <div className="highlighted-pest-scientific-name">
          {pestData.scientificName}
        </div>
        <div>
          <strong>Origin:</strong> {pestData.origin}
          <br />
          <strong>Category:</strong> {pestData.category}
          <br />
          <strong>Region:</strong> {pestData.region}
        </div>
        <button
          className="usa-button"
          onClick={() => navigate(pestData.learnMoreLink)}
          aria-label={"Select to load map data for " + pestData.commonName}
        >
          View Info with Map
        </button>
      </div>
    </div>
  );
}

export default HighlightedPest;
